// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* About Page Container */
.about-section {
  max-width: 760px;
  padding: 50px;
  background-color: #4b2e1e;
  position: absolute;
  top: 20%;
  color: #eaeaea;
  border-radius: 12px;
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
}

/* Main Title */
.about-section h1 {
  font-size: 2.8rem;
  text-align: center;
  margin-bottom: 25px;
  letter-spacing: 1.5px;
}

/* Paragraphs */
.about-section p {
  line-height: 1.8;
  color: #cfcfcf;
  margin-bottom: 35px;
  font-size: 1.05rem;
}

/* Section Subtitle */
.about-section h2 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  position: relative;
  padding-left: 15px;
}

/* Accent Line */
.about-section h2::before {
  content: "";
  position: absolute;
  left: 0;
  top: 5px;
  width: 4px;
  height: 70%;
  background-color: #f4c430;
  border-radius: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/about.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB;;;;cAIY;AACd;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":["/* About Page Container */\n.about-section {\n  max-width: 760px;\n  padding: 50px;\n  background-color: #4b2e1e;\n  position: absolute;\n  top: 20%;\n  color: #eaeaea;\n  border-radius: 12px;\n  font-family:\n    system-ui,\n    -apple-system,\n    BlinkMacSystemFont,\n    sans-serif;\n}\n\n/* Main Title */\n.about-section h1 {\n  font-size: 2.8rem;\n  text-align: center;\n  margin-bottom: 25px;\n  letter-spacing: 1.5px;\n}\n\n/* Paragraphs */\n.about-section p {\n  line-height: 1.8;\n  color: #cfcfcf;\n  margin-bottom: 35px;\n  font-size: 1.05rem;\n}\n\n/* Section Subtitle */\n.about-section h2 {\n  font-size: 1.5rem;\n  margin-bottom: 15px;\n  position: relative;\n  padding-left: 15px;\n}\n\n/* Accent Line */\n.about-section h2::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 5px;\n  width: 4px;\n  height: 70%;\n  background-color: #f4c430;\n  border-radius: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
